import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, CircularProgress, Theme } from '@material-ui/core';
import { dataProviderRegistry, DataImportControlDefinition, DFSExpression } from '../services';
import { makeStyles, createStyles } from '@material-ui/styles';
import React, { useContext, useState, FC, Fragment, useEffect } from 'react';
import { BehaviorSubject } from 'rxjs';

import { ExpressionManager } from '../services/ExpressionManager';
import { FormContext } from '../FormContext';
import { FormControlProps, useEditability } from '../utils';
import { createSelector } from 'reselect';
import { AppState } from '../../../../redux';
import { useSelector } from 'react-redux';
// import { registry } from '../registry';

export interface DataImportProps extends FormControlProps<DataImportControlDefinition> {
}

const useStyles = makeStyles((_: Theme) => {
  return createStyles({
    root: {
      alignItems: 'top',
      marginTop: function(props: DataImportProps) {
        return props.definition.label ? '24px' : '0px';
      }
    },
    progress: {},
    button: {
      verticalAlign: 'middle'
    }
  })
});

export const selectRoles = createSelector(
  (state: AppState) => state?.session?.dfdmToken?.profile?.roles,
  roles => roles
);

export const DataImport: FC<DataImportProps> = function(props) {
  const definition = props.definition;
  const editPermissions = definition.permissions?.edit;
  const context = useContext(FormContext);
  const onSetData = context.onSetData;
  const scope = context.scope;
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState<string | null>(null);
  const classes = useStyles(props);
  const [ editPermitted, setEditPermitted ] = useState(false);
  const roles = useSelector(selectRoles);
  const editable = useEditability(definition.editable);

  useEffect(() => {
    if (editPermissions && roles && Array.isArray(roles)) {
      if (Array.isArray(editPermissions)) {
        if (roles?.some(role => editPermissions.includes(role))) {
          setEditPermitted(true);
        } else {
          setEditPermitted(false);
        }
      } else {
        if (roles?.includes(editPermissions)) {
          setEditPermitted(true);
        } else {
          setEditPermitted(false);
        }
      }
    } else {
      setEditPermitted(true);
    }
  }, [roles, editPermissions])

  function f() {
    var provider = dataProviderRegistry.getDataProvider(definition.request.serviceID);
    if (!provider) {
      setMessage('There was a problem loading information. Please update your application');
      return;
    }
    setLoading(true);
    provider.getData(definition.request.params)
      .then(function e(t: any) {
        if (t !== null) {
          const mapMgr = new ExpressionManager(new BehaviorSubject(t));
          const _loop_1 = function(dataPath: string, mapping: DFSExpression) {
            mapMgr.watch(mapping).subscribe(function(value) {
              onSetData(dataPath, scope, value === undefined ? null : value);
            })
          };

          for (const [dataPath, mapping] of Object.entries(definition.mapping)) {
            _loop_1(dataPath, mapping);
          }
          mapMgr.complete();
        }
        setLoading(false);
        setMessage(null)
    }, function e(reason: string) {
      setLoading(false);
      setMessage(reason);
    })
  }
  const handleCloseMessage = function() {
    return setMessage(null);
  };
  return (!editPermissions || (editPermissions && editPermitted)) ? (
      <div className = { classes.root }>
        <Dialog
          onClose = { handleCloseMessage }
          open = { message !== null }>
          <DialogTitle>
            Unable to import
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              { message }
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick = { handleCloseMessage }
              color = { 'primary' }
              autoFocus = { true }>
              OK
            </Button>
          </DialogActions>
          {
            loading && <CircularProgress className = { classes.progress } size = { 16 }/>
          }
        </Dialog>
        <Button
          className = { classes.button }
          variant = { 'outlined' }
          color = { 'secondary' }
          onClick = { f }
          disabled = { loading || !editable }>
          { definition.title }
        </Button>
      </div>
    ) : <Fragment></Fragment>
};

// registry.registerComponent('DataImport', exports.DataImport);
